import { useMemo } from 'react';
import type { Route } from '~/hooks/useRoute';
import { isYyyymmdd } from '~/scripts/yyyymmdd';
import type { Filters } from '~/types/filters';
import {
  checkIfNumber,
  isAddedOrRemovedField,
  isNumber,
  isNumberField,
  isStringField,
  ValueOf,
} from '@shared/filters/utils';

export default function useFiltersFromQueryParam(
  filtersParam: ValueOf<Route['query']> | undefined
): Filters.Filters {
  return useMemo(() => {
    return getFiltersFromQueryParam(filtersParam);
  }, [filtersParam]);
}

export function getFiltersFromQueryParam(
  filtersParam: ValueOf<Route['query']> | undefined
): Filters.Filters {
  const filters: Partial<Filters.Filters> = {};

  if (typeof filtersParam !== 'object' || filtersParam === null) {
    return filters as Filters.Filters;
  }

  for (const [key, value] of Object.entries(filtersParam)) {
    if (typeof value === 'undefined') {
      continue;
    }
    if (isNumberField(key)) {
      filters[key] = checkIfNumber(value, undefined);
      continue;
    }

    if (isStringField(key)) {
      if (Array.isArray(value) && value.length > 0) {
        filters[key] = value;
      } else if (typeof value === 'string' && value) {
        filters[key] = [value];
      }
      continue;
    }

    if (
      isAddedOrRemovedField(key) &&
      value &&
      isNumber(+value) &&
      isYyyymmdd(value.toString())
    ) {
      filters[key] = checkIfNumber(value, undefined);
    }
  }

  return filters as Filters.Filters;
}
